import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { MainSkinInterface, setEditId, setEditError, selectMainSkinById } from "../../../store/mods_factory/mainSkinsSlice";
import { updateMainSkin, fetchMainSkin } from "../../../actions/mods_factory/mainSkinsActions";
import { objToFormData } from "../../../helpers/FormHelper";
import { fetchCategories } from "../../../actions/mods_factory/categoriesActions";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const TARGET_ID = 5;

const Edit = () => {
  const navigate      = useNavigate();
  const dispatch      = useAppDispatch();
  const location      = useLocation();
  const id: any       = useAppSelector(state => state.modsFactory.mainSkins.editId);
  const error         = useAppSelector(state => state.modsFactory.mainSkins.editError);
  const mainSkin = useAppSelector(state => id ? selectMainSkinById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchMainSkin(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: MainSkinInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: MainSkinInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateMainSkin({ id, data: formData }));

    if (updateMainSkin.fulfilled.match(resultAction)) {
      onClose();

      if (mainSkin?.category_id !== data.category_id || mainSkin?.subcategory_id !== data.subcategory_id) {
        navigate(0);
      }
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-mainSkin'>
        <h6 className="v-content-label">Edit Entity Skin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={mainSkin} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
